import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';

import type { GrowthCompanyGoal, GrowthGoal } from '../../data-contract/growth';
import { useGoalAction } from '../api/growth-mutations';
import { CompanyGoalPicker, CompanyGoalSummary } from '../components/CompanyGoalPicker';
import { DetailSection } from '../components/GrowthTileFrame';

export const CompanyGoalSection: FunctionComponent<{
    readonly canEdit: boolean;
    readonly companyGoals: readonly GrowthCompanyGoal[];
    readonly goal: GrowthGoal;
}> = ({ canEdit, companyGoals, goal }) => {
    const translate = useTranslate();
    const goalAction = useGoalAction(goal.id);
    const paysInto = companyGoals.find(({ id }) => id === goal.paysIntoId);

    if (companyGoals.length === 0) {
        return null;
    }

    return (
        <DetailSection title={translate('pages.growth.detail.pays-into')}>
            {canEdit ? (
                <CompanyGoalPicker
                    companyGoals={companyGoals}
                    disabled={goalAction.isPending}
                    value={goal.paysIntoId}
                    onChange={(paysIntoId) => goalAction.mutate({ action: 'set-pays-into', paysIntoId })}
                />
            ) : paysInto === undefined ? (
                <span className="text-body-s text-text-muted">{translate('pages.growth.form.no-company-goal')}</span>
            ) : (
                <div className="rounded-xl border border-border-subtle px-xl py-l">
                    <CompanyGoalSummary goal={paysInto} />
                </div>
            )}
        </DetailSection>
    );
};
